import '../sass/blocks/blog.scss';
import { initializeArticleContents } from './utils/article-contents.mjs';

initializeArticleContents();

document.querySelectorAll('[data-blog-categories]').forEach((rail) => {
    const current = rail.querySelector('[aria-current="page"]');
    if (!current) return;
    window.requestAnimationFrame(() => {
        if (rail.scrollWidth <= rail.clientWidth) return;
        const bounds = rail.getBoundingClientRect();
        const item = current.getBoundingClientRect();
        rail.scrollLeft += item.left - bounds.left - (rail.clientWidth - item.width) / 2;
    });
});
